var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666748 12C0.666748 5.37258 6.03933 0 12.6667 0C19.2942 0 24.6667 5.37258 24.6667 12C24.6667 18.6274 19.2942 24 12.6667 24C6.03933 24 0.666748 18.6274 0.666748 12Z",
    fill: "#F6F6F6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13595_23030)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4003 6.16678C11.4376 6.16678 10.1228 6.75234 9.47919 7.46789L6.18081 11.1329C5.75138 11.6098 5.55081 12.5024 5.73545 13.1177L6.81484 16.7157C6.99893 17.3303 7.67513 17.8334 8.31702 17.8334H18.5C19.1449 17.8334 19.6668 17.311 19.6668 16.6667V6.16675L12.4003 6.16678ZM7.49453 11.4166L10.3461 8.24838C10.77 7.7778 11.768 7.33333 12.4003 7.33333H18.5V11.4166H7.49453ZM18.5 13.75H16.1668V12.5833H18.5V13.75Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13595_23030"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(5.66675 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoors);
export default __webpack_public_path__ + "static/media/doors.676b8390cc0502b8c9610ba18b497562.svg";
export { ForwardRef as ReactComponent };